
import { Component } from 'react';

class BaseView extends Component {
  constructor(props) {
    super(props);
    
    if (this.constructor === BaseView) {
      throw new TypeError('Abstract class "BaseView" cannot be instantiated directly.'); 
    }

    if (this.constructor.VIEW_PATH === undefined) {
      throw new TypeError('Classes extending the "BaseView" abstract class must implement "VIEW_PATH" static variable.');
    }
  }

  static getPathWithoutParams() {
    return this.VIEW_PATH.replace(/:[a-zA-Z0-9]+\??/, '');
  }

  static getPath(params) {
    let pagePath = "/LegacySearch"+this.VIEW_PATH;

    if (!params) {
      return pagePath;
    }

    pagePath += '?';
    for (let key in params) {
      let value = params[key];

      if (pagePath.includes(`:${key}`) || pagePath.includes(`:${key}?`)) {
        pagePath = pagePath.replace(`:${key}`, value);
        pagePath = pagePath.replace(`:${key}?`, value);
      } else if (Array.isArray(value)) {
        for (let i in value) {
          pagePath += `${encodeURIComponent(key)}=${encodeURIComponent(value[i])}&`;
        }
      } else {
        pagePath += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
      }
    }

    return pagePath;
  }

  getSearch(location = this.props.location) {
    if (!location) {
      return null;       
    }

    const urlSearchParams = new URLSearchParams(location.search);
    let search = {};
    
    for (let key of urlSearchParams.keys()) { 
      search[key] = urlSearchParams.get(key);
    };

    return search;
  }
  
}

export default BaseView;